module.exports = __webpack_public_path__ + "packs/media/images/lexiqamus/landing/original-document-2c3daf4f2ec5e5fe435719ccc9317e18.png";